module.exports = __webpack_public_path__ + "app-static/img/02.9547a4bd.jpg";